
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/province-directory",
      function () {
        return require("private-next-pages/province-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/province-directory"])
      });
    }
  